import * as React from 'react';

export interface TwoOptionModalComponentProps {
    itemId: string
    itemContent: string
    button1Function: Function
    button1Text: string
    button2Function: Function
    button2Text: string
}

const TwoOptionModalComponent = (props: TwoOptionModalComponentProps) => {


    return (
        <div className="modal fade" id={props.itemId} tabIndex={-1} >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">Are you sure?</h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {props.itemContent}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <a href="#"><button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => props.button1Function()}>{props.button1Text}</button></a>
                        <a href="#"><button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => props.button2Function()}>{props.button2Text}</button></a>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default TwoOptionModalComponent;